export default "__VITE_ASSET__SFh5Dkf8__"